import type { ReactNode } from 'react';
import { X } from 'lucide-react';
import type { HeldPage } from './scan-pages';

export interface ScanPagesProps {
  pages: HeldPage[];
  scanning: boolean;
  onRemove: (index: number) => void;
}

/** The pages as they arrive from the feeder, each removable before they go to the job. */
export function ScanPages({ pages, scanning, onRemove }: ScanPagesProps): ReactNode {
  if (pages.length === 0 && !scanning) return null;
  return (
    <ul className="paige-scan-pages" aria-label="Scanned pages">
      {pages.map((page, i) => (
        <li key={page.index}>
          <img src={page.preview} alt={`Page ${i + 1}`} width={page.width} height={page.height} />
          <span>{i + 1}</span>
          <button
            type="button"
            aria-label={`Remove page ${i + 1}`}
            onClick={() => onRemove(page.index)}
            disabled={scanning}
          >
            <X size={12} />
          </button>
        </li>
      ))}
      {scanning && (
        <li className="is-waiting" aria-live="polite">
          <span>Waiting for the scanner…</span>
        </li>
      )}
    </ul>
  );
}
